import { IconName } from '@ardoq/icons';
import { DropdownMenuOption } from '@ardoq/dropdown-menu-ui';

type ModalExpandableSectionProps = {
  focused: boolean;
  toggleExpandedState: () => void;
  isExpanded: boolean;
  forceExpand: boolean;
};

const ModalExpandableSection = ({
  focused,
  toggleExpandedState,
  isExpanded,
  forceExpand,
}: ModalExpandableSectionProps) => (
  <DropdownMenuOption
    isFocused={focused}
    isDisabled={forceExpand}
    onClick={toggleExpandedState}
    label={isExpanded ? 'Less' : 'More'}
    rightIconName={isExpanded ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN}
    align="right"
  />
);

export { ModalExpandableSection };
